
<script>
import { mapGetters } from "vuex";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  name: "baseContent",
  mixins: [vipBadge],
  data() {
    return {
      type: 0, //素材的属性，每个页面自己实现
      //分页加载的属性
      pageIndex: 1,
      loadingStatus: 0, //加载状态 0为加载完毕，1为加载中，2为没有更多数据

      //条件过滤
      category: null, //分类
      sort: null, //排序
      commerical: null, //授权
      price: null, //价格
      direction: null, //横竖版

      categorys: [{ id: null, name: "全部" }],
      sortFlags: [
        { name: "推荐", value: "" }
        // { name: "最新", value: "&orderBy=2" },
      ],
      commericalFlags: [
        { name: "全部", value: "" },
        { name: "商用", value: "&isCommerical=1" },
      ],

      directionFlags: [
        { name: "横版", value: "1", type: 0 },
        { name: "竖版", value: "2", type: 1 },
      ],
      priceFlags: [], //每个页面自己重写

      currentStyle: null, //当前风格
      keyWord: "", //关键词
      contentList: [], //素材列表
    };
  },
  computed: {
    ...mapGetters([
      "StyleArrayMsg",
      "StyleDataMsg",
      "WorksId",
      "WorksName",
      "TOOL",
      "UserMsg",
      'IsOldUser'
    ]),
    ...mapGetters({
      trackingData: "tracking/trackingData",
    }),
    resourceLevelOptions () {
      if (this.IsOldUser) {
        return [
          { name: "全部", value: "" },
          { name: "免费", value: "&payType=0" },
          // { name: "付费", value: "&payType=1" },
          { name: "会员专属", value: "&payType=4" },
          { name: "企业会员专属", value: "&payType=6" },
        ]
      }
      const isProLevelSystem = this.IsProLevelSystem
      return [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        // { name: "付费", value: "&payType=1" },
        { name: this.getOptionName(6), value: "&payType=6" },
        { name: this.getOptionName(4), value: "&payType=4" },
      ]
    },
    resourceLevelOptions2 () {
      if (this.IsOldUser) {
        return [
          { name: "全部", value: "" },
          { name: "免费", value: "&payType=0" },
          { name: "付费", value: "&payType=1" },
          { name: "会员专属", value: "&payType=4" },
          { name: "企业会员专属", value: "&payType=6" },
        ]
      }
      return [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        { name: "付费", value: "&payType=1" },
        { name: this.getOptionName(6), value: "&payType=6" },
        { name: this.getOptionName(4), value: "&payType=4" },
      ]
    }
  },
  methods: {
    trackSearchResultClick(item = {}) {
      if (this.keyWord) {
        sensors.track("searchResultClick", {
          choose_price: this.trackingData.choose_price,
          click_type: "添加到画布",
          keyword_type: this.trackingData.keyword_type,
          keyword: this.trackingData.keyword,
          order_method: this.trackingData.order_method,
          position_number: "",
          search_source: "编辑器素材弹窗",
          template_id: this.$route.template || "",
          template_name: "",
          template_style: "",
          template_type: "",
          material_id: item.id,
          // material_name: item.title,
        });
      }
    },
    setTrackingData(url) {
      let decoded = this.$qs.decode(url.split("?")[1]);
      this.$store.commit("tracking/setTrackingData", {
        search_type: "素材搜索",
        keyword: decoded.keyword,
        choose_price: ((payType) => {
          if (payType == 0) {
            return "免费";
          }
          if (payType == 1) {
            return "付费";
          }
          if (payType == 4) {
            return "会员免费";
          }
          return "全部价格";
        })(decoded.payType),
        order_method: ((orderBy) => {
          if (orderBy == 2) {
            return "最新上传";
          }
          return "综合排序";
        })(decoded.orderBy),
      });
    },
    trackCollectContent(item, dict) {
      sensors.track("collectContent", {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: "",
        collect_content: item.collect_content || "",
        content_duration: this.TOOL.getDuration() / 1000,
        content_id: this.WorksId,
        content_name: this.WorksName,
        material_id: item.id,
        // material_name: item.title,
        module: "编辑器素材弹窗",
        operation_type: dict.isCancel == 1 ? "取消收藏" : "收藏",
        price_type: ((payType) => {
          if (payType == 0) {
            return "免费";
          }
          if (payType == 1) {
            return "付费";
          }
          if (payType == 4) {
            return "会员免费";
          }
          return "全部价格";
        })(item.payType || (item.sprite || {}).payType),
        price: (item.price || (item.sprite || {}).price || 0) - 0,
        purpose: "",
        template_id: this.$route.template || "",
        template_name: "",
        template_style: "",
        template_type: "",
      });
    },
    //导航到当前组件
    async activePage(navParam) {
      if (this.currentStyle !== this.StyleDataMsg) {
        this.currentStyle = this.findFirstById(
          this.StyleArrayMsg,
          this.StyleDataMsg.id
        );
        this.category = null;
        await this.getCategorys();
      }
      this.resetFilter(navParam);
    },

    switchPage() {
      if (!this.category) {
        this.category = this.categorys[0];
        this.refreshContentList();
      }
    },
    //获取分类信息
    async getCategorys() {
      let requestBody = {
        type: this.type,
        // style: this.currentStyle.id,
      };
      let response = await this._getCategorys(requestBody);
      if (response) {
        this.categorys = [{ id: null, name: "全部" }].concat(response);
      }
    },

    _getCategorys: function (requestBody) {
      var url = "/api/home/category";
      return this.$http
        .get(url, {
          params: requestBody,
        })
        .then((res) => {
          //console.log(JSON.stringify(res.data.data));
          let data = [];
          for (const key in res.data.data) {
            data.push(res.data.data[key]);
          }
          data = data.sort(function (a, b) {
            return a.power - b.power;
          });

          return data;
        })
        .catch((error) => {
          return null;
        });
    },

    //重置条件过滤选项
    resetFilter(navParam) {
      if (navParam) {
        //从工具进来
        if (navParam.optimized === "Vertical") {
          this.direction = this.directionFlags[1];
        }

        if (navParam.category) {
          let findCategory = this.findFirstById(
            this.categorys,
            navParam.category
          );
          if (findCategory) {
            this.category = findCategory;
          } else {
            this.category = this.categorys[0];
          }
        }
      }
      if (!this.category) {
        this.category = this.categorys[0];
      }
    },

    //发生了条件过滤筛选
    filterChanged: function (value) {
      //console.log(value);
      this.refreshContentList();
    },

    //刷新素材列表数据
    refreshContentList: function () {
      this.loadingStatus = 1;
      this.pageIndex = 1;
      this.contentList = [];
      this.getContentList();
    },

    //文字查询
    onSearch: function (keyWord) {
      this.keyWord = keyWord;
      this.$store.commit("tracking/setTrackingData", {
        search_type: "素材搜索",
        keyword: keyWord,
      });
      this.refreshContentList();
    },

    //风格改变
    async onStyleChange() {
      await this.getCategorys();
      this.category = this.categorys[0];
      this.refreshContentList();
    },

    findFirstById(array, key) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] && array[i].id === key) {
          return array[i];
        }
      }
      return null;
    },

    showLikesToast (type = 'likes') {
      if (type === 'likes') {
        this.$message({
          message: "收藏成功",
          type: "success",
        });
      }
      if (type === 'unlikes') {
        this.$message('收藏已取消');
      }
    }
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/baseContent.vue